import { Component, OnInit } from '@angular/core';
import { DataIoService } from '../../../services/data-io.service';
import { MenuService } from '../../../services/menu.service';
import { NavBarService } from '../../../services/nav-bar.service';
@Component({
  selector: 'basic-menu-indicator',
  templateUrl: './menu-indicator.component.html',
  styleUrls: ['./menu-indicator.component.scss']
})
export class MenuIndicatorComponent implements OnInit {

  constructor(
  	private menuService:MenuService, 
  	private ioService: DataIoService,
  	private navbarService:NavBarService
  	) { }

  ngOnInit() {
  }
  getIconState(icon){
  	let state = this.navbarService.getState(icon);
  	return this.navbarService.getState(icon);
  }
}
